/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  IScheduleListMethods,
  ScheduleListService,
  IResendMailShelfMethods,
  ResendMailService,
  IGetSchedulesReportMethods,
  GetSchedulesReportService
} from "./components";

export type SchedulePageAgent = IHeaderMethods &
  ISettingsMethods &
  IStaticPageContentMethods &
  IResendMailShelfMethods &
  IScheduleListMethods &
  IGetSchedulesReportMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new ResendMailService(),
    new ScheduleListService(),
    new GetSchedulesReportService()
  ];
};

export const getAgent = () => {
  return createAgent<SchedulePageAgent>({
    plugins: getPlugins(),
  });
};
